<p-multiSelect
            [options]="options"
            optionLabel="name"
            optionValue="itemId"
            [showToggleAll]="true"
            [filter]="true"
            [placeholder]="'--Select--'"
            [(ngModel)]="selectedOptions"
            (ngModelChange)="onModelChange($event)"
            [appendTo]="'body'"
            [virtualScroll]="false"
            [emptyFilterMessage]="'No match'"
            [emptyMessage]="'No options'">
</p-multiSelect>
